import { render, staticRenderFns } from "./CapturaNomina.vue?vue&type=template&id=eb33b63e&scoped=true"
import script from "./CapturaNomina.vue?vue&type=script&lang=js"
export * from "./CapturaNomina.vue?vue&type=script&lang=js"
import style0 from "./CapturaNomina.vue?vue&type=style&index=0&id=eb33b63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb33b63e",
  null
  
)

export default component.exports